import React from "react";

const Search = props => (
  <svg viewBox="0 0 21 21" fill="none" {...props}>
    <path
      d="M16.583 8.625a8.123 8.123 0 01-1.562 4.805l4.922 4.96c.508.47.508 1.29 0 1.758a1.205 1.205 0 01-1.758 0l-4.961-4.96c-1.328 1.015-3.008 1.562-4.766 1.562A8.119 8.119 0 01.333 8.625C.333 4.172 3.966.5 8.458.5c4.454 0 8.125 3.672 8.125 8.125zM8.458 14.25a5.578 5.578 0 004.844-2.813c1.016-1.718 1.016-3.867 0-5.624C12.287 4.093 10.451 3 8.458 3c-2.03 0-3.867 1.094-4.882 2.813-1.016 1.757-1.016 3.906 0 5.625a5.594 5.594 0 004.882 2.812z"
      fill="currentColor"
    />
  </svg>
);

export default Search;
